<script lang="ts">
import { defineComponent } from "vue";
import { getOutByIndex, OutDef } from "@/shared/utils/outs";
import { injectOut } from "@/shared/utils/injection";

export default defineComponent({
  ...injectOut,

  computed: {
    outDef(): OutDef {
      return getOutByIndex(this.out!.index);
    },
  },

  methods: {
    resynchro() {
      this.out.withSyncColor = true;
      return this.savePool();
    },
    change() {
      this.out.withChangeColor = true;
      return this.savePool();
    },
  },
});
</script>
<template>
  <div
    class="card mb-2 p-3"
    v-if="
      !isPoolDirty &&
      outDef.name === 'OUT_LIGHT' &&
      [0, 2, 6].includes(out.mode)
    "
  >
    <div class="flex gap-2">
      <div class="text-lg font-medium grow">{{ $t("LightChangeTitle") }}</div>
      <div class="btn--primary" @click="change">{{ $t("LightColor") }}</div>
      <div class="btn--primary" @click="resynchro">
        {{ $t("LightResynchro") }}
      </div>
    </div>
  </div>
</template>
